export const RoomTypeForms = {
  CreateRoomType: 'createRoomType',
  UpdateRoomType: 'updateRoomType',
};
